import { loadComponent } from './utils/loadComponent';
export class RemoteMicrofrontend {
    constructor(options) {
        this.options = options;
    }
    load() {
        return loadComponent(this.options.remote, 'default', `./${this.options.module}`, this.options.remoteEntryUrl);
    }
}
